import {
  Container,
  Table
} from "reactstrap";

import { useTheme } from "../hooks/useTheme";

const DataTableMatrix = ({
  name,
  label,
  rows,
  columns,
  data,
  width = "100%",
  footerValues = []
}) => {
  const theme = useTheme();


  return (
    <>
      <Container fluid className="px-0">
        <Table
          className={theme === "dark-mode" ? "no-wrap mt-3 align-middle table-dark" : "no-wrap mt-3 align-middle"}
          hover
          responsive
          striped
          style={{ width: width, minWidth: "300px" }}
        >
          <thead>
            <tr>
                <th 
                    style={{borderBottom: "3px solid var(--bs-border-color)", borderRight: "3px solid var(--bs-border-color)", textAlign: "left"}}
                    className="pb-3"
                >{label}</th>
              {columns.map((col) => (
                <th
                    key={col.key}
                    style={{borderBottom: "3px solid var(--bs-border-color)"}}
                    className="text-end p-3"
                >
                    {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr
                key={row.key}
              >
                <th style={{borderRight: "3px solid var(--bs-border-color)"}}>{row.label}</th>
                {columns.map((col) => {
                    const cell = data[row.key]?.[col.key];

                    return (
                        <td 
                            key={col.key}
                            className="text-end p-3"
                        >
                            {cell?.render ? cell.render(row.key, col.key) : cell?.value ?? '\u00A0'}
                        </td>
                    );
                })}
              </tr>
            ))}
            {footerValues.length > 0 && (
                <tr>
                    <th style={{borderTop: "3px solid var(--bs-border-color)", borderRight: "3px solid var(--bs-border-color)"}}>Total</th>
                    {footerValues.map((value, index) => (
                        <td key={index} className="text-end p-3" style={{borderTop: "3px solid var(--bs-border-color)"}}>
                            {value}
                        </td>
                    ))}
                </tr>
            )}
          </tbody>
        </Table>
      </Container>
    </>
  );
};

export default DataTableMatrix;
